export default __webpack_public_path__ + "static/media/ic-credit-card-yellow.71a95067.svg";